<template>
    <div class="pro">
        <Inbanner />
        <Structure />
        <Advantage />
        <Client />
        <div class="consult" :style="{backgroundImage: 'url(' + bannerimg + ')','background-repeat':'no-repeat','background-size':'cover','background-position':'center',}">
            <div class="container">
                <el-row :gutter="20">
                    <el-col :span="8" style="padding-top:70px;">
                        <h3>咨询行业专业顾问</h3>
                        <p>关于使用场景和技术架构的更多咨询， 请联系我们的销售和技术支持团队。</p>
                        <div >  <el-button type="primary" @click="handleAdd">立即咨询</el-button></div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <NewsDialog :visible.sync="dialogVisible"/>
    </div>
</template>
<script>
import Inbanner from './pages/Inbanner'
import Structure from './pages/Structure'
import Client from './pages/Client'
import Advantage from './pages/Advantage'
import NewsDialog from '../news/pages/newsDialog.vue'

export default{
    data() {
        return {
           bannerimg: require('../../assets/img/zixun_bg.jpg'),
           dialogVisible: false
        };
    },
    components:{
        Inbanner,Structure,Client,Advantage,NewsDialog
    },
    methods: {
      handleAdd(){
        this.dialogVisible = true
      }
    }
}
</script>
<style>
.consult{
    height: 400px;
    text-align: left;
}
.consult h4{
    margin-bottom: 20px;
}
.consult p{
    margin-bottom: 50px;
}
</style>